var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.nbItems != 0)?_vm._t("default"):_vm._e(),_c('img',{attrs:{"src":require("@/assets/icons/Cart.png"),"width":this.width,"height":this.height}})],2)}
var staticRenderFns = []

export { render, staticRenderFns }